var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInitialLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 64,
    viewBox: "0 0 264 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13723_118729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.626 44.7355H125.747C125.747 44.7355 125.747 30.5817 125.747 28.2518C125.747 23.4141 121.626 23.4141 121.626 23.4141V44.7355Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62 44.7355H100.499C100.499 44.7355 100.499 30.5817 100.499 28.2518C100.499 23.4141 104.62 23.4141 104.62 23.4141V44.7355Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.776 19.293C115.519 19.293 110.179 19.293 109.468 19.293C104.63 19.293 104.63 23.4139 104.63 23.4139H121.614C121.614 23.4139 121.614 19.293 116.776 19.293Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.165 44.7355H41.286C41.286 44.7355 41.286 30.5817 41.286 28.2518C41.286 23.4141 37.165 23.4141 37.165 23.4141V44.7355Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5576 44.7355H22.6786C22.6786 44.7355 22.6786 30.5817 22.6786 28.2518C22.6786 23.4141 18.5576 23.4141 18.5576 23.4141V44.7355Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14437 44.7355H-0.976562C-0.976562 44.7355 -0.976562 30.5817 -0.976562 28.2518C-0.976562 23.4141 3.14437 23.4141 3.14437 23.4141V44.7355Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6187 19.293C12.3613 19.293 8.70349 19.293 7.99201 19.293C3.1543 19.293 3.1543 23.4139 3.1543 23.4139H18.548C18.548 23.4139 18.4564 19.293 13.6187 19.293Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3107 19.293C31.0533 19.293 24.1146 19.293 23.4031 19.293C18.5654 19.293 18.5654 23.4139 18.5654 23.4139H37.1467C37.1467 23.4139 37.1467 19.293 32.309 19.293H32.3107Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4878 19.25C69.4878 19.25 56.0507 19.25 53.7208 19.25C48.8831 19.25 48.8831 23.4343 48.8831 23.4343H65.1872C65.1872 23.4343 65.1872 34.3865 65.1872 36.6337C65.1872 39.1415 63.9333 40.575 61.0663 40.575C58.1992 40.575 48.869 40.575 48.869 40.575V23.4255C48.869 23.4255 44.748 24.1423 44.748 27.189V44.7382C44.748 44.7382 57.6621 44.7382 62.1423 44.7382C66.6207 44.7382 69.4878 42.0508 69.4878 37.2131V19.2518V19.25Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3101 19.25C97.3101 19.25 83.873 19.25 81.543 19.25C76.7053 19.25 76.7053 23.4343 76.7053 23.4343H93.0095C93.0095 23.4343 93.0095 34.3865 93.0095 36.6337C93.0095 39.1415 91.7556 40.575 88.8885 40.575C86.0215 40.575 76.6912 40.575 76.6912 40.575V23.4255C76.6912 23.4255 72.5703 24.1423 72.5703 27.189V44.7382C72.5703 44.7382 85.4844 44.7382 89.9646 44.7382C94.443 44.7382 97.3101 42.0508 97.3101 37.2131V19.2518V19.25Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.213 29.7188C180.05 29.7047 180.149 33.8274 180.149 33.8274H167.871C163.033 33.8274 163.049 29.7188 163.049 29.7188C163.049 29.7188 172.883 29.7258 175.213 29.7188Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.127 44.7423H184.248C184.248 44.7423 184.248 26.4411 184.248 24.1111C184.248 19.2734 180.127 19.2734 180.127 19.2734V44.7423Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.047 44.7423H158.926C158.926 44.7423 158.926 26.4411 158.926 24.1111C158.926 19.2734 163.047 19.2734 163.047 19.2734V44.7423Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.921 23.3964V19.2578C152.921 19.2578 138.822 19.2578 136.503 19.2578C131.684 19.2578 131.729 23.4316 131.729 23.4316L152.921 23.3964Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.978 40.6367V44.7418C131.978 44.7418 146.123 44.7418 148.444 44.7418C153.262 44.7418 153.285 40.6367 153.285 40.6367H131.978Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.48 29.9648C153.298 29.9648 153.302 34.0664 153.302 34.0664H136.492C131.674 34.0664 131.737 29.9648 131.737 29.9648H148.48Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.284 40.6359V34.06C153.284 34.06 156.826 33.7307 156.826 37.0098C156.826 37.1912 156.826 37.6262 156.826 37.8111C156.826 40.5813 153.282 40.6341 153.282 40.6341L153.284 40.6359Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.737 23.4297V29.9563C131.737 29.9563 128.195 30.2539 128.195 26.9748C128.195 26.7934 128.195 26.5045 128.195 26.3196C128.195 23.5494 131.739 23.4315 131.739 23.4315L131.737 23.4297Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.473 19.2891C263.311 19.2803 263.647 23.4347 263.647 23.4347C263.647 23.4347 249.763 23.4312 247.433 23.4347C242.595 23.4435 242.259 19.2891 242.259 19.2891C242.259 19.2891 256.143 19.2926 258.473 19.2891Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.386 44.7885H255.507C255.507 44.7885 255.507 30.8002 255.507 28.4703C255.507 23.6326 251.386 23.4336 251.386 23.4336V44.7885Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.358 19.25C212.358 19.25 198.921 19.25 196.591 19.25C191.753 19.25 191.753 23.4343 191.753 23.4343H208.057C208.057 23.4343 208.057 34.3865 208.057 36.6337C208.057 39.1415 206.803 40.575 203.936 40.575C201.069 40.575 191.739 40.575 191.739 40.575V23.4255C191.739 23.4255 187.618 24.1423 187.618 27.189V44.7382C187.618 44.7382 200.532 44.7382 205.012 44.7382C209.491 44.7382 212.358 42.0508 212.358 37.2131V19.2518V19.25Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.997 19.25C239.997 19.25 226.559 19.25 224.23 19.25C219.392 19.25 219.392 23.4343 219.392 23.4343H235.696C235.696 23.4343 235.696 34.3865 235.696 36.6337C235.696 39.1415 234.442 40.575 231.575 40.575C228.708 40.575 219.378 40.575 219.378 40.575V23.4255C219.378 23.4255 215.257 24.1423 215.257 27.189V44.7382C215.257 44.7382 228.171 44.7382 232.651 44.7382C237.13 44.7382 239.997 42.0508 239.997 37.2131V19.2518V19.25Z",
    fill: "#0E0E0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13723_118729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialLogo);
export default __webpack_public_path__ + "static/media/initial-logo.ab027c4ff6479d48396d3573604f4a71.svg";
export { ForwardRef as ReactComponent };